import { render } from "./SolutionLayout.vue?vue&type=template&id=ca306e4e&scoped=true"
import script from "./SolutionLayout.vue?vue&type=script&lang=js"
export * from "./SolutionLayout.vue?vue&type=script&lang=js"

import "./SolutionLayout.vue?vue&type=style&index=0&id=ca306e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca306e4e"]])

export default __exports__